class ProductParameterShowcase extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-param-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-param-panel]'));

    if (!this.buttons.length || this.buttons.length !== this.panels.length) {
      return;
    }

    const activeButtonIndex = this.buttons.findIndex((button) => button.classList.contains('is-active'));
    this.activeIndex = activeButtonIndex > -1 ? activeButtonIndex : 0;

    this.onButtonClick = this.handleButtonClick.bind(this);
    this.onKeyDown = this.handleKeyDown.bind(this);

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick);
    });

    this.addEventListener('keydown', this.onKeyDown);
    this.setActive(this.activeIndex, false);
  }

  disconnectedCallback() {
    if (!this.buttons || !this.buttons.length) {
      return;
    }

    this.buttons.forEach((button) => {
      button.removeEventListener('click', this.onButtonClick);
    });

    this.removeEventListener('keydown', this.onKeyDown);
  }

  handleButtonClick(event) {
    const target = event.currentTarget;
    const nextIndex = Number(target.dataset.paramTrigger);
    if (Number.isNaN(nextIndex)) {
      return;
    }

    this.setActive(nextIndex, false);
  }

  handleKeyDown(event) {
    const trigger = event.target.closest('[data-param-trigger]');
    if (!trigger || !this.contains(trigger)) {
      return;
    }

    let nextIndex = null;
    if (event.key === 'ArrowRight') {
      nextIndex = (this.activeIndex + 1) % this.buttons.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (this.activeIndex - 1 + this.buttons.length) % this.buttons.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.buttons.length - 1;
    }

    if (nextIndex === null) {
      return;
    }

    event.preventDefault();
    this.setActive(nextIndex, true);
  }

  setActive(index, moveFocus) {
    if (index < 0 || index >= this.buttons.length) {
      return;
    }

    this.activeIndex = index;

    this.buttons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-selected', String(isActive));
      button.setAttribute('tabindex', isActive ? '0' : '-1');

      if (isActive && moveFocus) {
        button.focus();
      }
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', String(!isActive));
    });
  }
}

if (!customElements.get('product-parameter-showcase')) {
  customElements.define('product-parameter-showcase', ProductParameterShowcase);
}
